import { NodeViewWrapper } from "@tiptap/react";
import type { NodeViewProps } from "@tiptap/react";

import { cn } from "@/lib/utils";

import { useEditorField } from "./fields-context";

export function FieldView({ node, selected }: NodeViewProps) {
	const { field, template, readOnly } = useEditorField(node.attrs.fieldId);

	const unknown = field === undefined;
	const unresolved = !unknown && !template && (field.value === null || field.value === undefined);
	const plain = readOnly && !template && !unknown && !unresolved;

	return (
		<NodeViewWrapper
			as="span"
			data-component="document-field"
			className={cn(
				template && "field-chip",
				!template &&
					!plain &&
					"inline-flex items-baseline whitespace-nowrap rounded-sm px-0.5 ring-1 ring-inset",
				!template && !plain && !unknown && !unresolved && "bg-primary/10 ring-primary/25",
				!template && !plain && unresolved && "bg-warning/15 ring-warning/40",
				!template && !plain && unknown && "bg-destructive/10 ring-destructive/40",
				selected && !readOnly && "ring-2 ring-ring",
			)}
			data-field-id={node.attrs.fieldId}
			data-value={field?.value}
		>
			{unknown && "campo removido"}
			{!unknown && (template ? field.label : (field.value ?? field.label))}
		</NodeViewWrapper>
	);
}
